import { useEffect, useState } from "react";
import { useAddress, useShowVideo } from "../contexts/Context";
import ModalVideo from "./ModalVideo";
import playIcon from "../assets/new-ui/play-video.png";

export default function HolysharksCGI() {
  const [showVideo, setShowVideo] = useShowVideo();
  const [videoBox, setVideoBox] = useState(false);
  const [ethAddress] = useAddress();

  useEffect(() => {
    if (showVideo) {
      setVideoBox(true);
      setShowVideo(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showVideo]);

  return (
    <>
      <ModalVideo toggleModal={videoBox} setToggleModal={setVideoBox} />
      <div
        className={
          !ethAddress ? "holysharksCGI" : "holysharksCGI holysharksCGILower"
        }
        onClick={() => setVideoBox(true)}
      >
        <img src={playIcon} alt="play icon" />
        <div className="cgiText">SHARKTOPIA CGI</div>
      </div>
    </>
  );
}
